<div>
  <div class="mb-2">
    Zlecenie realizacji płatności: Zlecenie wykonuje PayU SA; Dane odbiorcy,
    tytuł oraz kwota płatności dostarczane są PayU SA przez odbiorcę; Zlecenie
    jest przekazywane do realizacji po otrzymaniu przez PayU SA Państwa wpłaty.
    Płatność udostępniana jest odbiorcy w ciągu 1 godziny, nie później niż do
    końca następnego dnia roboczego; PayU SA nie pobiera opłaty od realizacji
    usługi.
  </div>

  <div class="mb-2">
    Płacąc akceptujesz
    <app-external-link
      [underline]="true"
      link="https://static.payu.com/sites/terms/files/payu_terms_of_service_single_transaction_pl_pl.pdf">
      <span>Zasady płatności PayU.</span>
    </app-external-link>
  </div>

  <div class="mb-2">
    Administratorem Twoich danych osobowych jest PayU S.A. z siedzibą w Poznaniu
    (60-166), przy ul. Grunwaldzkiej 186 ("PayU"). Twoje dane osobowe będą
    przetwarzane w celu realizacji transakcji płatniczej, powiadamiania Cię o
    statusie realizacji Twojej płatności, rozpatrywania reklamacji, a także w
    celu wypełnienia obowiązków prawnych ciążących na PayU.
  </div>

  <div class="flex justify-center">
    <button
      (click)="handleReadMoreClick()"
      class="border-none border-gray-200 bg-none font-bold outline-hidden">
      {{ readMoreLabel() }}
    </button>
  </div>

  @if (readMore()) {
    <div class="mt-4">
      Masz prawo do dostępu, poprawiania, ograniczenia lub sprzeciwu wobec
      przetwarzania Twoich danych osobowych, a także prawo do przenoszenia
      danych i ich usunięcia. Podanie danych jest dobrowolne jednak niezbędne do
      realizacji płatności, a brak podania danych może skutkować odrzuceniem
      płatności. Więcej informacji o zasadach przetwarzania Twoich danych
      osobowych przez PayU znajdziesz w
      <app-external-link
        [underline]="true"
        link="https://poland.payu.com/prywatnosc/polityka-prywatnosci-payu/">
        <span>Polityce Prywatności</span>
      </app-external-link>
      <span>.</span>
    </div>
  }
</div>
